const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRevenueUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 4,
    stroke: "#323232",
    fill: "none",
    d: "M11.116 75.188C49.832 71.763 72.369 49.921 79.091 10",
    style: {
      stroke: "rgb(45, 101, 188)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.091 10l-14.205 7.697",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 4,
    stroke: "#323232",
    fill: "none",
    style: {
      stroke: "rgb(45, 101, 188)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.091 10l9.793 12.849",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 4,
    stroke: "#323232",
    fill: "none",
    style: {
      stroke: "rgb(45, 101, 188)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 5,
    stroke: "#849b87",
    fill: "none",
    d: "M40.605 20.93H25.116a6.195 6.195 0 0 0-6.195 6.195v0a6.195 6.195 0 0 0 6.195 6.195h12.391a6.195 6.195 0 0 1 6.195 6.195v0a6.195 6.195 0 0 1-6.195 6.195H18.921",
    style: {
      stroke: "rgb(200, 200, 50)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.938 16.425v33.792",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 5,
    stroke: "#849b87",
    fill: "none",
    style: {
      stroke: "rgb(200, 200, 50)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.685 16.425v33.792",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 5,
    stroke: "#849b87",
    fill: "none",
    style: {
      stroke: "rgb(200, 200, 50)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.489 90h-20.48",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3,
    stroke: "#323232",
    fill: "none",
    style: {
      stroke: "rgb(45, 101, 188)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.609 77.916h20.48V90h-20.48z",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3,
    stroke: "#323232",
    fill: "none",
    style: {
      stroke: "rgb(45, 101, 188)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.21 61.721h20.48V90H65.21z",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3,
    stroke: "#323232",
    fill: "none",
    style: {
      stroke: "rgb(45, 101, 188)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenueUpload);
export default __webpack_public_path__ + "static/media/revenue_upload.d68165b921af5727a88f016a17877d90.svg";
export { ForwardRef as ReactComponent };